export const handleClonePage =
    (customTemplateId, addTemplatePages, addNewPages) =>
    (cloneTemplateId, pages) => {
        addTemplatePages(customTemplateId, cloneTemplateId, pages, addNewPages);
    };
